// extracted by mini-css-extract-plugin
export default {"root":"certificatePage_root__C0KG+","innerWrapper":"certificatePage_innerWrapper__ZwCcc"};